<template>
  <div class="wrap">
    <img :src="imgConfig[namespace]" />
    <div class="service" @click="serviceCenter">
      <svg-icon iconClass="bj-service-by" />客服中心
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  computed,
  onMounted,
  ref,
} from "@vue/composition-api";

import { useStore } from "@/components/use/base";
import { jsonSafeParse } from "@/utils/index";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const store = useStore();
    const imgConfig = ref({});

    const namespace = computed(() => store.state.namespace);

    onMounted(() => {
      initImage();
    });

    const initImage = () => {
      imgConfig.value = jsonSafeParse(vm.$getConfigValue("BJ_VISITOR_PAGE"));
    };

    const serviceCenter = () => {
      window.location.href =
        "https://oakvip.s2.udesk.cn/im_client/?web_plugin_id=62106";
    };

    return {
      namespace,
      imgConfig,
      serviceCenter,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  position: relative;
  height: 100%;
  padding-bottom: 80px;

  img {
    width: 100%;
  }

  .service {
    position: absolute;
    width: 343px;
    height: 32px;
    background: #ffffff;
    border-radius: 8px;
    bottom: 33px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 15px;
    color: #333333;
    line-height: 21px;

    svg {
      height: 20px;
      width: 22px;
      margin-right: 9px;
    }
  }
}
</style>